export enum BDEType {
  RAMP = 'RampAndKeepDelta',
  STAY = '', //TODO verify data
}